'use strict';

var define = require('define-properties');

var ES = require('es-abstract/es6');

var implementation = require('./implementation');

var getPolyfill = require('./polyfill');

var polyfill = getPolyfill();

var shim = require('./shim');

var slice = Array.prototype.slice;
/* eslint-disable no-unused-vars */

var boundIncludesShim = function includes(array, searchElement) {
  /* eslint-enable no-unused-vars */
  ES.RequireObjectCoercible(array);
  return polyfill.apply(array, slice.call(arguments, 1));
};

define(boundIncludesShim, {
  getPolyfill: getPolyfill,
  implementation: implementation,
  shim: shim
});
module.exports = boundIncludesShim;